import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';
import { getDefaultHeight } from '../utils/get-default-height.js';

const WavesGraphic = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 2601 86.7",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 86.7),
    ...svgProps,
    stroke: svgProps.stroke ?? "none",
    fill: color ?? svgProps.fill ?? "currentColor",
    children: [/*#__PURE__*/jsx("path", {
      d: "M2601,87.7H0V45C195.8,57,423.3,9.3,536.2,10.7c103,1.3,151.1,30.4,434.4,30.4s329.8-7,491.5-34.9 c82.7-14.3,252.8,49.5,337.5,38c68.6-9.3,176.4-44.1,238.1-29.8c215.7,50.1,443.9,9.6,563.3,25.3V87.7L2601,87.7z",
      fillOpacity: 0.3
    }), /*#__PURE__*/jsx("path", {
      d: "M2021.2,87.7H2601V-0.1c-67.1,113.3-408.9-8.3-582.4,26.1s-256.5-20.6-379.3-7.5s-214.9,25.7-498.2,25.7S804.8,5,659.1,18.5 c-107.9,10-258.8,41.6-371.2,22.1C128.4,2.7,89.3,50.9,0,39.4v48.3h581.7H2021.2z"
    })]
  });
};

export { WavesGraphic };
//# sourceMappingURL=waves.js.map
